import { useContext, useMemo } from 'react';
import { Box, Button } from '@mui/material';
import { NamedTree } from '~/src/model/NamedTree';
import {
	BulkDesignContext,
	BULK_DESIGN_VIEW_MODE,
} from '~/src/design/bulk/store';
import TreeViewColumn from './TreeViewColumn';
import { columns } from './helper/utils';

interface LeftBarProps {
	toggleEditMode: () => void;
	addTemplate: () => void;
	treeData: NamedTree<unknown>;
	duplicateItem: () => void;
}

function LeftBarHeader({
	addTemplate,
	treeData,
}: LeftBarProps) {
	const { mainViewMode } = useContext(BulkDesignContext);

	const gridTemplateColumns = useMemo(() => {
		if (mainViewMode === BULK_DESIGN_VIEW_MODE.LIST_VIEW) {
			return `minmax(12px, 12px) 1fr repeat(${columns.length}, auto) 176px`;
		}
		return '12px 1fr auto';
	}, [mainViewMode]);

	return (
		<Box
			className="tree-view__head"
			style={{
				gridTemplateColumns,
			}}
		>
			{/* empty space with 12px width */}
			<Box className="index"></Box>
			{/* Project Name */}
			<Box className="tree-view__head-title">
				<Box component="span" className="title-icon">
					<img src="/img/treeview/checklist.svg" alt="" />
				</Box>
				<Box
					component="span"
					style={{
						whiteSpace: 'nowrap',
						overflow: 'hidden',
						textOverflow: 'ellipsis',
					}}
				>
					{treeData.Name}
				</Box>
			</Box>
			{/* Columns - visible only in itemized list view */}
			{mainViewMode === BULK_DESIGN_VIEW_MODE.LIST_VIEW && (
				<>
					{columns.map((column) => (
						<TreeViewColumn key={column.id} column={column} />
					))}
				</>
			)}
			{/* button group */}
			<Box className="tree-view__head-actions">
				<Box className="tree-view__head-btn">
					<Button onClick={() => addTemplate()}>
						<svg width="20" height="20" viewBox="0 0 20 20" fill="#F7FAFC">
							<g id="Icon">
								<path
									id="Vector"
									d="M9.16663 9.1665V4.1665H10.8333V9.1665H15.8333V10.8332H10.8333V15.8332H9.16663V10.8332H4.16663V9.1665H9.16663Z"
									fill="#F7FAFC"
								/>
							</g>
						</svg>
					</Button>
				</Box>
				{/* <Box className="tree-view__head-btn">
					<Button onClick={() => toggleEditMode()}>
						<svg width="20" height="20" viewBox="0 0 20 20" fill="#F7FAFC">
							<g id="Icon">
								<path
									id="Vector"
									d="M8.33336 12.6433L15.9934 4.98242L17.1725 6.16076L8.33336 14.9999L3.03003 9.69659L4.20836 8.51826L8.33336 12.6433Z"
									fill="#F7FAFC"
								/>
							</g>
						</svg>
					</Button>
				</Box> */}
				{/* <Box className="tree-view__head-btn">
					<Button>
						<img src="/img/treeview/disk.svg" alt="" />
					</Button>
				</Box>
				<Box className="tree-view__head-btn">
					<Button>
						<img src="/img/treeview/disk-with-arrow.svg" alt="" />
					</Button>
				</Box> */}
				{/* <Box className="tree-view__head-btn">
					<Button onClick={() => duplicateItem()}>
						<svg width="18" height="18" viewBox="0 0 18 18" fill="transparent">
							<g id="clone vector">
								<path
									id="Box"
									d="M16.9002 5.50683V15.887C16.9002 16.4393 16.4525 16.887 15.9002 16.887H5.48291C4.93063 16.887 4.48291 16.4393 4.48291 15.887V5.50684C4.48291 4.95455 4.93063 4.50684 5.48291 4.50684H15.9002C16.4525 4.50684 16.9002 4.95455 16.9002 5.50683Z"
									stroke="#F7FAFC"
									stroke-width="1.5"
								/>
								<path
									id="Half Line"
									d="M13.5169 3.35083V2.11328C13.5169 1.561 13.0692 1.11328 12.5169 1.11328H2.09961C1.54733 1.11328 1.09961 1.561 1.09961 2.11328V12.4934C1.09961 13.0457 1.54732 13.4934 2.09961 13.4934H3.33698"
									stroke="#F7FAFC"
									stroke-width="1.5"
								/>
							</g>
						</svg>
					</Button>
				</Box> */}
				{/* <Box className="tree-view__head-btn">
					<Button>
						<img src="/img/treeview/lock-icon.svg" alt="" />
					</Button>
				</Box> */}
			</Box>
		</Box>
	);
}

export default LeftBarHeader;
